import { render, staticRenderFns } from "./Projects.vue?vue&type=template&id=190f1258"
import script from "./Projects.ts?vue&type=script&lang=ts&external"
export * from "./Projects.ts?vue&type=script&lang=ts&external"
import style0 from "./Projects.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports